import { render, staticRenderFns } from "./InventarioPilha.vue?vue&type=template&id=8106e308&scoped=true"
import script from "./InventarioPilha.vue?vue&type=script&lang=js"
export * from "./InventarioPilha.vue?vue&type=script&lang=js"
import style0 from "../../../css/crud.css?vue&type=style&index=0&id=8106e308&prod&scoped=true&lang=css&external"
import style1 from "./InventarioPilha.vue?vue&type=style&index=1&id=8106e308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8106e308",
  null
  
)

export default component.exports